import { createFileRoute } from '@tanstack/react-router';
import { EmployeesPage } from '@/features/portal/employees';
import { Forbidden } from '@/features/portal/ui';
import { useIsAdmin } from '@/features/auth/use-auth';

/** UA-20/SH-06: administration is reachable only with the administrator flag; a direct URL shows تم رفض الوصول. */
function EmployeesRoute() {
  const isAdmin = useIsAdmin();
  return isAdmin ? <EmployeesPage /> : <Forbidden />;
}

export const Route = createFileRoute('/_app/employees')({
  component: EmployeesRoute,
});
